import { lazyInitializeOwaAccountsStore } from 'owa-account-store-init';

export default async function initOWAAccount() {
    lazyInitializeOwaAccountsStore.importAndExecute();

    return true;
}
